import { Button, Modal, Progress } from "antd";
import React, { useEffect, useRef, useState } from "react";
import WebUtils from "../../utils/WebUtils";
import { endInterviewApi } from "../../../api";

function InterviewEndModal({
  chanceOverModal,
  interviewData,
  setLoading,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  timeRemainingRef,
  chatMessagesRef,
  ip,
  stopRecording,
  fraudSnapshotAPiCall,
  allowUnloadRef
}) {
  const [logCode, setLogCode] = useState(
    "End interview finished with cheating detect"
  );
  const [logMessage, setLogMessage] = useState(
    "Candidate is trying to cheat and exceeded their chance"
  );
  const [secondsRemaining, setSecondsRemaining] = useState(5);
  const endInterviewFlag = useRef(false);
  const endIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    setLoading(true);
    // console.log(
    //   "Video, Screen, Api :",
    //   videoBlobQueueRef.current.length,
    //   screenShareBlobQueueRef.current.length,
    //   endInterviewFlag.current
    // );
    if (
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      endInterviewFlag.current &&
      fraudSnapshotAPiCall.current
    ) {
      setLoading(false);
      clearInterval(endIntervalRef.current);
      allowUnloadRef.current = true
      window.location.href = `/interview-completed?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };
  let logs = WebUtils.logData();
  const callEndInterviewApi = () => {
    let url = endInterviewApi;

    let browserData = navigator;
    const logBody = {
      ...logs,
      role: interviewData?.userRole,
      name: interviewData?.name,
      ipAddress: ip,
      //   dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: logCode,
      logMessage: logMessage,
    };

    const requestBody = {
      interviewId: interviewData?.interviewId,
      ipLog: logBody,
      interviewType: interviewData?.interviewType,
      timeLeft: timeRemainingRef.current,
      interviewConversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
        endInterviewFlag.current = true;
      })
      .catch((err) => {
        endInterviewFlag.current = true;
        console.log(err);
      });
  };
  useEffect(() => {
    stopRecording();
    const totalDuration = 5000; // 5 seconds
    const intervalDuration = 1000; // 1 second

    const countdownInterval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          endIntervalRef.current = setInterval(endInterviewFunc, 500);
          callEndInterviewApi();
          return 0;
        }
        return prev - 1;
      });

      // Decrease progress by 20% each second
    }, intervalDuration);

    return () => clearInterval(countdownInterval);
  }, []);
  return (
    <Modal
      title="End Interview"
      open={chanceOverModal}
      //   onOk={handleOk}
      onCancel={() => {
        callEndInterviewApi();
        endIntervalRef.current = setInterval(endInterviewFunc, 500);
      }}
      centered
      footer={null}
    >
      <p className=" mt-4">
        You have switched away from the window too many times, the interview
        will be ended automatically.
      </p>
      <div className="text-lg mt-4 text-center w-full">
        Your interview will end in...{" "}
        <p className="w-[60px] inline-block font-semibold ">
          {" "}
          {secondsRemaining} sec.
        </p>
      </div>
    </Modal>
  );
}

export default InterviewEndModal;
